<template>
  <ul>
    <li
      v-for="session in sessions"
      :key="session"
      class="session"
      v-text="session"
    />
  </ul>
</template>

<script>
  export default {
    props: {
      sessions: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .session {
    & + & {
      margin-top: spacing(gamma);
    }
  }
</style>
